// src/components/ProjectProgressCard.jsx
import React from "react";

const getProgressColor = (progress) => {
  if (progress >= 75) return "bg-green-500";       // green for high progress
  if (progress >= 50) return "bg-yellow-400";      // yellow for medium progress
  return "bg-red-500";                             // red for low progress
};

const ProjectProgressCard = ({ project }) => {
  // Use the overallProgress field returned from backend
  const progress = project?.overallProgress ?? 0;

  return (
    <div className="bg-white shadow-md rounded-lg p-4 border-l-4 border-orange-600">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-md font-semibold text-orange-600">
          {project.projectTitle}

        </h3>
        <span className="text-sm text-gray-600">
          Status:{" "}
          <span className="font-semibold text-gray-800">{project.status}</span>
        </span>
      </div>
      <div className="mt-2">
        <div className="w-full bg-gray-200 rounded-full h-3">
          <div
            className={`h-3 rounded-full transition-all duration-500 ${getProgressColor(progress)}`}
            style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
          ></div>
        </div>
        <p className="text-sm text-gray-700 mt-1">
          Progress: <span className="font-semibold">{Math.round(progress)}%</span>
        </p>
      </div>
    </div>
  );
};

export default ProjectProgressCard;